import {ApplicationActionTypes, MyAxisState, Version} from "./types";
import {
  fetchError, fetchRequest, fetchSuccess, fetchVersion, fetchVersionError, fetchVersionSuccess,
  fetchFirmware, fetchFirmwareSuccess, fetchFirmwareError
} from "./actions";
import {createReducer} from "typesafe-actions";

export const initialState: MyAxisState = {
  loading: false,
  errors: undefined,
  applications: [],
  versions: {},
  firmwares: [],
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof fetchVersion>
  | ReturnType<typeof fetchVersionSuccess>
  | ReturnType<typeof fetchVersionError>
  | ReturnType<typeof fetchFirmware>
  | ReturnType<typeof fetchFirmwareSuccess>
  | ReturnType<typeof fetchFirmwareError>;

export default createReducer<MyAxisState, ActionType>(initialState)
  .handleType(ApplicationActionTypes.FETCH, state => ({
    ...state,
    loading: true,
    applications: [],
    errors: undefined
  }))
  .handleType(ApplicationActionTypes.FETCH_SUCCESS, (state, action) => ({
    ...state,
    loading: false,
    applications: (action.payload || []),
    errors: undefined
  }))
  .handleType(ApplicationActionTypes.FETCH_ERROR, (state, action) => ({
    ...state,
    loading: false,
    applications: [],
    errors: action.payload
  }))
  .handleType(ApplicationActionTypes.FETCH_VERSION, state => ({
    ...state,
    loading: true,
    errors: undefined
  }))
  .handleType(ApplicationActionTypes.FETCH_VERSION_SUCCESS, (state, action) => {
    const { applicationData, application, versions } : Version = action.payload;
    return ({
      ...state,
      loading: false,
      versions: {
        ...state.versions,
        [application]: {
          applicationData,
          versions
        }
      },
      errors: undefined
    })
  })
  .handleType(ApplicationActionTypes.FETCH_VERSION_ERROR, (state, action) => ({
    ...state,
    loading: false,
    versions: {},
    errors: action.payload
  }))
  .handleType(ApplicationActionTypes.FETCH_FIRMWARE, state => ({
    ...state,
    loading: true,
    firmwares: [],
    errors: undefined
  }))
  .handleType(ApplicationActionTypes.FETCH_FIRMWARE_SUCCESS, (state, action) => {
    const { model, version }  = action.payload;

    return {
      ...state,
      loading: false,
      firmwares: {
        ...state.firmwares,
        [model]: version || []
      },
      errors: undefined
    }
  })
  .handleType(ApplicationActionTypes.FETCH_FIRMWARE_ERROR, (state, action) => ({
    ...state,
    loading: false,
    firmwares: [],
    errors: action.payload
  }));

